import { motion } from "framer-motion";

export const Flyout = ({ i, flyExpanded, setFlyExpanded, flyElement, parent }) => {
    const isFlyOutOpen = i === flyExpanded;
    
    const flyOutVariants = {
        open: {display: "block", opacity: 1, left: "18px"},
        closed: { opacity: 0, right: '-1300px', display: "none"},
    };

    const genFlyout = (sub) => {
        return sub.map((link, i) => {
            return <li key={i}>
                <a href={link.Url}>{link.Name}</a>
            </li>
        })
    }

    return <li key={i}>
        <button className="flyout-trigger" onClick={() => setFlyExpanded(isFlyOutOpen ? false : i)}>{flyElement.MenuName}</button>
        {isFlyOutOpen && (
            <motion.ul 
            custom={i}
            animate={"open"} 
            exit="closed"
            variants={flyOutVariants}
            className="mobile-flyout-menu flyout-level">
            <li>
                <button className="flyback-trigger" onClick={() => setFlyExpanded(isFlyOutOpen ? false : i)}>&lt;&nbsp;<span>{parent}</span></button>
            </li>
            <li className="level-overview">
                <a href={flyElement.Url}>{flyElement.MenuName}</a>
            </li>
            {genFlyout(flyElement.Flyout)}
        </motion.ul>
        )
    }</li>
}